import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
var AssetService = /** @class */ (function (_super) {
    tslib_1.__extends(AssetService, _super);
    function AssetService(http) {
        var _this = _super.call(this, http, MapperService.assetMap) || this;
        _this._endpoint = '/odata/Assets';
        return _this;
    }
    return AssetService;
}(ODataService));
export { AssetService };
